import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PrimaryButton } from '../../../shared/components/common/primary_button';
import * as authActions from '../../../data/reducers/auth.reducer';
import { useParams } from 'react-router';
import { AppDispatch } from '../../../data/storeConfig';
import { useSelector } from 'react-redux';
import { RootState } from '../../../data/reducers';
import { CountryCode } from '../../../data/models/country_codes_response';
import { constants } from '../../../config';

export const MobileInputComponent = () => {
  const { storeSlug } = useParams<any>();
  const { isLoading, countryCodes } = useSelector((state: RootState) => state.authReducer);
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const dispatch = useDispatch<AppDispatch>();
  const [contactNumber, setContactNumber] = useState('');
  const [countryCode, setCountryCode] = useState<CountryCode>();

  useEffect(() => {
    dispatch(authActions.fetchCountryCodes());
  }, []);

  const sendOtp = (e: any) => {
    e.preventDefault();
    if (storeInfo) {
      dispatch(
        authActions.sendOtp({
          countryCode: countryCode?.dialingCode ?? '',
          contactNumber: contactNumber,
          storeSlug: storeSlug ?? '',
          merchantStoreId: storeInfo?.merchantStoreId,
        }),
      );
    }
  };

  useEffect(() => {
    if (countryCodes.length > 0) {
      const countryCodeSelected = countryCodes?.find((cc: CountryCode) => cc.countryCode == 'PH');
      setCountryCode(countryCodeSelected);
    }
  }, [countryCodes]);

  return (
    <div className="mx-auto my-auto flex justify-center items-center" style={{ height: '85vh'}}>
      <form className="text-left" onSubmit={sendOtp}>
        <h2 className="text-3xl text-theDarkOne font-semibold">Your mobile number</h2>
        <h3 className="text-sm text-theLighterDark">100% safe, it is never used to spam you.</h3>
        <div className="flex justify-center mt-8">
          <div className="mb-3 w-full xl:w-96">
            <label
              htmlFor="phoneNumberInput"
              className="form-label inline-block mb-2 text-theDarkOne font-medium text-sm"
            >
              Mobile number
            </label>
            <div className="input-group flex flex-row w-full xl:w-96 h-12">
              <div className="input-group-text flex items-center px-3 py-1.5 text-base border-gray-300 border-r-0 rounded-lg border focus:border-4 text-ellipsis">
                {countryCodes.length > 0 ? (
                  <select
                    className="text-ellipsis"
                    disabled={constants.ENV == 'PROD'}
                    style={{ maxWidth: 70 }}
                    onChange={(e: any) => {
                      setCountryCode(JSON.parse(e.currentTarget.value));
                    }}
                    defaultValue={JSON.stringify(countryCodes?.find((cc: CountryCode) => cc.countryCode == 'PH'))}
                  >
                    {constants.ENV == 'PROD'
                      ? countryCodes
                          ?.filter((cc: CountryCode) => cc.countryCode == 'PH')
                          .map((c: CountryCode) => (
                            <option
                              className="text-ellipsis"
                              key={c.countryCode}
                              value={JSON.stringify(c)}
                            >{`+${c.dialingCode}`}</option>
                          ))
                      : countryCodes.map((c: CountryCode) => (
                          <option
                            className="text-ellipsis"
                            key={c.countryCode}
                            value={JSON.stringify(c)}
                          >{`+${c.dialingCode}`}</option>
                        ))}
                  </select>
                ) : (
                  <>...</>
                )}
              </div>
              <input
                type="tel"
                className="form-control flex-auto px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border-l-0 border border-solid border-gray-300 rounded-r-lg transition ease-in-out m-0 focus:text-theDarkOne focus:bg-white focus:border-primaryViolet focus:border-l-0 focus:outline-none"
                id="phoneNumberInput"
                placeholder="Mobile number"
                required={true}
                pattern={countryCode?.regex}
                onChange={(e) => setContactNumber(e.currentTarget.value)}
              />
            </div>
          </div>
        </div>
        <PrimaryButton
          text="Send OTP"
          onclick={() => {
            console.log('Log in');
            console.log(countryCode);
          }}
          isLoading={isLoading}
        />
      </form>
    </div>
  );
};
